import { ComponentType } from '@candu-ai/styleguide/types';
import { BlankForm } from 'craft/components/FormTab/BlankForm';

import {
  BadgeDropIn,
  ButtonDropIn,
  CardDropIn,
  ChecklistDropIn,
  CodeDropIn,
  ColumnDropIn,
  ContentDropIn,
  ConditionalViewDropIn,
  DividerDropIn,
  DynamicFlowDropIn,
  FormCheckboxDropIn,
  FormEmailInputDropIn,
  FormMultiSelectCardsDropIn,
  FormSelectInputDropIn,
  FormSingleSelectCardsDropIn,
  FormSubmitButtonDropIn,
  FormTextAreaDropIn,
  FormTextInputDropIn,
  IFrameDropIn,
  ImageDropIn,
  LeftImgViewDropIn,
  PlayerDropIn,
  RightImgViewDropIn,
  SingleViewDropIn,
  StackedViewDropIn,
  TypographyDropIn,
} from './DropIns';
import { ComponentsSidebar, ComponentUnfilteredSession } from './types';

export const allComponents: ComponentUnfilteredSession[] = [
  {
    label: 'Layouts',
    anchor: ComponentsSidebar.Layouts.anchor,
    builtIn: [
      {
        label: 'SingleView',
        Component: SingleViewDropIn,
      },
      {
        label: 'Columns',
        Component: ColumnDropIn,
      },
      {
        label: 'StackedView',
        Component: StackedViewDropIn,
      },
      {
        label: 'RightImgView',
        Component: RightImgViewDropIn,
      },
      {
        label: 'LeftImgView',
        Component: LeftImgViewDropIn,
      },
      {
        label: 'ConditionalView',
        Component: ConditionalViewDropIn,
      },
    ],
  },

  {
    label: 'Typography',
    anchor: ComponentsSidebar.Typography.anchor,
    styleguideSection: ComponentType.Typography,
    styleguide: {
      section: 'typography',
      Component: TypographyDropIn,
    },
    builtIn: [
      {
        label: 'Code',
        Component: CodeDropIn,
      },
    ],
  },

  {
    label: 'Buttons',
    anchor: ComponentsSidebar.Buttons.anchor,
    styleguideSection: ComponentType.Button,
    styleguide: {
      section: 'button',
      Component: ButtonDropIn,
    },
  },

  {
    label: 'Cards',
    anchor: ComponentsSidebar.Cards.anchor,
    styleguideSection: ComponentType.Card,
    styleguide: {
      section: 'card',
      Component: CardDropIn,
    },
  },

  {
    label: 'Media',
    anchor: ComponentsSidebar.Media.anchor,
    builtIn: [
      {
        label: 'Player',
        Component: PlayerDropIn,
      },
      {
        label: 'Image',
        Component: ImageDropIn,
      },
    ],
  },

  {
    label: 'Multi-Step Flows',
    anchor: ComponentsSidebar.Flows.anchor,
    builtIn: [
      {
        label: 'EmptyFlow',
        Component: DynamicFlowDropIn,
      },
    ],
  },

  /**
   * Forms
   */
  {
    label: 'Form Container',
    anchor: ComponentsSidebar.Forms.anchor,
    builtIn: [
      {
        label: 'FormContainer',
        Component: BlankForm,
      },
    ],
  },
  {
    label: 'Form Fields',
    styleguideSection: ComponentType.Form,
    anchor: ComponentsSidebar.Forms.anchor,
    builtIn: [
      {
        label: 'Input',
        Component: FormTextInputDropIn,
      },
      {
        label: 'TextArea',
        Component: FormTextAreaDropIn,
      },
      {
        label: 'Select',
        Component: FormSelectInputDropIn,
      },
      {
        label: 'Email',
        Component: FormEmailInputDropIn,
      },
      {
        label: 'Checkbox',
        Component: FormCheckboxDropIn,
      },
      {
        label: 'MultiSelectCards',
        Component: FormMultiSelectCardsDropIn,
      },
      {
        label: 'SingleSelectCards',
        Component: FormSingleSelectCardsDropIn,
      },
      {
        label: 'SubmitButton',
        Component: FormSubmitButtonDropIn,
      },
    ],
  },

  {
    label: 'Checklists',
    anchor: ComponentsSidebar.Checklists.anchor,
    styleguideSection: ComponentType.Checklist,
    styleguide: {
      section: 'checklist',
      Component: ChecklistDropIn,
    },
  },

  {
    label: 'Badges',
    anchor: ComponentsSidebar.Badges.anchor,
    styleguideSection: ComponentType.Badge,
    styleguide: {
      section: 'badge',
      Component: BadgeDropIn,
    },
  },

  {
    label: 'Divider',
    anchor: ComponentsSidebar.Divider.anchor,
    builtIn: [
      {
        label: 'Divider',
        Component: DividerDropIn,
      },
    ],
  },

  {
    label: 'Embeds',
    anchor: ComponentsSidebar.Embeds.anchor,
    builtIn: [
      {
        label: 'Content',
        Component: ContentDropIn,
      },
      {
        label: 'IFrame',
        Component: IFrameDropIn,
      },
    ],
  },
];
